import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fl posRe borderGrey rad20 ofh",
  style: {"width":"320px","height":"280px"}
}
const _hoisted_2 = {
  style: {},
  class: /*#__PURE__*/_normalizeClass(`posRe`)
}
const _hoisted_3 = {
  key: 0,
  class: "w100",
  style: {"height":"180px","width":"320px"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "w100 pad10" }
const _hoisted_6 = {
  class: "fl fw600",
  style: {"width":"230px"}
}
const _hoisted_7 = { class: "fr" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switcher = _resolveComponent("Switcher")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.room)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.hasImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.room.appeal_content.image_url,
                  height: "180",
                  width: "320",
                  style: {"object-fit":"cover"}
                }, null, 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createVNode(_component_Switcher, {
                value: "type[is_active]",
                name: "設定の有効",
                checked: _ctx.isActive,
                display: "true",
                class: "checkUsingCal fr posAb",
                onSelect: _ctx.changeActive
              }, null, 8, ["checked", "onSelect"]), [
                [_directive_tooltip, `設定を${_ctx.isActive ? `無効` : `有効`}にします`]
              ])
            ]),
            _hoisted_8
          ]),
          _hoisted_9
        ])
      ]))
    : _createCommentVNode("", true)
}